
export type TenantApis = {
    openid: string;
    coreApi: string;
};

export function getTenantConfig() {
    var result: TenantApis = { coreApi: null!, openid: null! };

    if (process.env.NODE_ENV == "development")
        result = {
            openid: process.env.REACT_APP_OpenIdUrl as string,
            coreApi: process.env.REACT_APP_CoreApiUrl as string
        };
    else
        result = {
            openid: document.getElementById('p-openid-api-url')?.getAttribute("content") ?? "",
            coreApi: document.getElementById('p-core-api-url')?.getAttribute("content") ?? ""
        };

    if (!result.coreApi) throw ("TenantService: 'coreApi' is undefined.");
    if (!result.openid) throw ("TenantService: 'openid' is undefined.");

    return result;
}

